import * as React from "react";
const SvgFiRrBottleDroplet = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M16.856 8.065 15 7.323V2a1 1 0 1 0 0-2H9a1 1 0 1 0 0 2v5.323l-1.856.742A4.98 4.98 0 0 0 4 12.708V19c0 2.757 2.243 5 5 5h6c2.757 0 5-2.243 5-5v-6.292a4.975 4.975 0 0 0-3.144-4.643M18 19c0 1.654-1.346 3-3 3H9c-1.654 0-3-1.346-3-3v-6.292c0-1.233.74-2.327 1.886-2.785l2.485-.994A1 1 0 0 0 11 8V2h2v6c0 .409.249.776.629.929l2.485.994A2.985 2.985 0 0 1 18 12.708zm-7.643-6.219C9.125 14.208 8.5 15.459 8.5 16.5c0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5c0-1.041-.625-2.292-1.857-3.72-.828-.955-2.457-.956-3.285 0zM12 18c-.827 0-1.5-.673-1.5-1.5 0-.193.099-.939 1.371-2.411a.167.167 0 0 1 .258-.001c1.272 1.473 1.371 2.219 1.371 2.412 0 .827-.673 1.5-1.5 1.5"
    />
  </svg>
);
export default SvgFiRrBottleDroplet;
